<template>
    <ul class="paginator ml-auto mr-auto clearfix">
        <li v-for="i in pages"
            class="c-pointer no-select"
            :class="{'active': i === page}"
            @click="$emit('changed', i)"
        ></li>
    </ul>
</template>

<script>
    export default {
        name: "Paginator",
        props: {
            pages: {
                type: Number,
                required: true
            },
            page: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/variables.scss";

    .paginator {
        $size: 9px;

        list-style: none;
        margin: 0;
        padding: 0;
        display: inline-block;

        li {
            display: block;
            margin: 0 4px;
            background: #CBCBCB;
            width: 110px;
            height: 5px;
            float: left;

            &.active {
                background: $blue;
            }
        }
    }
</style>